function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDownArrow = function SvgDownArrow(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 280 181",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-5770.71,-8297.49)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-45.8495,-5.35636)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1509.08,494.132)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-0.707107,-0.707107,0.580795,-0.580795,8276.75,17803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7715.87,7764.79C7715.87,7753.53 7708.36,7744.39 7699.12,7744.39L7525.11,7744.39C7515.86,7744.39 7508.35,7753.53 7508.35,7764.79L7508.35,7805.58C7508.35,7816.84 7515.86,7825.98 7525.11,7825.98L7699.12,7825.98C7708.36,7825.98 7715.87,7816.84 7715.87,7805.58L7715.87,7764.79Z",
    style: {
      fill: "rgb(166,214,255)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.707107,-0.707107,0.547344,0.547344,-2127.27,9021.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7715.87,7764.79C7715.87,7753.53 7706.73,7744.39 7695.47,7744.39L7528.75,7744.39C7517.49,7744.39 7508.35,7753.53 7508.35,7764.79L7508.35,7805.58C7508.35,7816.84 7517.49,7825.98 7528.75,7825.98L7695.47,7825.98C7706.73,7825.98 7715.87,7816.84 7715.87,7805.58L7715.87,7764.79Z",
    style: {
      fill: "rgb(49,131,200)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.554718,-0.554718,0.387581,0.387581,254.181,9114.68)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7508.35,
    y: 7744.39,
    width: 207.516,
    height: 81.591,
    style: {
      fill: "rgb(49,131,200)"
    }
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDownArrow, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/down-arrow.1ec3ffa9.svg";
export { ForwardRef as ReactComponent };